import { ColorSAP } from "./Colors";
export const FUNCTION_TYPE = {
    MM: 'MM',
    SD: 'SD',
    PP: 'PP',
    WM: 'WM',
    EWM: 'EWM',
    QM: 'QM'
};
export const getFunctionTypeBackgroundColor = type => {
    switch (type) {
        case FUNCTION_TYPE.MM:
            return ColorSAP.primary[30];
        case FUNCTION_TYPE.SD:
            return ColorSAP.neutral[20];
        case FUNCTION_TYPE.PP:
            return ColorSAP.danger[20];
        case FUNCTION_TYPE.WM:
            return ColorSAP.secondary[20];
        case FUNCTION_TYPE.EWM:
            return ColorSAP.success[20];
        case FUNCTION_TYPE.QM:
            return ColorSAP.neutral[80];
    }
};
export const getFunctionTypeLabelColor = type => {
    switch (type) {
        case FUNCTION_TYPE.MM:
            return ColorSAP.primary[80];
        case FUNCTION_TYPE.SD:
            return ColorSAP.neutral[90];
        case FUNCTION_TYPE.PP:
            return ColorSAP.danger[80];
        case FUNCTION_TYPE.WM:
            return ColorSAP.secondary[70];
        case FUNCTION_TYPE.EWM:
            return ColorSAP.success[80];
        case FUNCTION_TYPE.QM:
            return ColorSAP.neutral[0];
    }
};
